import { render, staticRenderFns } from "./TAddDomain.vue?vue&type=template&id=bb0b27fc&scoped=true&"
import script from "./TAddDomain.vue?vue&type=script&lang=js&"
export * from "./TAddDomain.vue?vue&type=script&lang=js&"
import style0 from "./TAddDomain.vue?vue&type=style&index=0&id=bb0b27fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0b27fc",
  null
  
)

export default component.exports